import React from "react";
import'./MainSpinner.css'
function MainSpinner() {
  return (
    <div className="loader-wrapper">
      <span className="loader"></span>
    </div>
  );
}

export default MainSpinner;
